export const SAVA_USER_INFO = 'SAVA_USER_INFO'
export const SAVA_SERVICE_INFO = 'SAVA_SERVICE_INFO'
export const FREE_RIGHT = 'FREE_RIGHT'
